import PCMobileApplications from "./PCMobileApplications"; // Ensure the correct import path
import MainBanner from'./MainBanner';
import Stack from'./Stack';
import Corcessbanner from './Corcessbanner';
import Coursesnew from './Coursesnew';

const App = () => {
  return (
    <div>
         {/* <MainBanner/>  */}
         {/* <Stack/>  */}
       
         
      {/* <Corcessbanner/> */}
      <Coursesnew/>
      {/* <PCMobileApplications />
      */}
    </div>
  );
};

export default App;
;